import React from 'react';
import './scss/contact.css';
import { HeaderText } from '../../styledcomponents/HeaderText/HeaderText'
import Footeritem from '../../styledcomponents/Footeritem/index.js'


const Contact = (props)=>{

    return (

        <div>
        <div className = "contact__wave" style={{height: "150px", overflow: "hidden"}} >
            <svg viewBox="0 0 500 150" preserveAspectRatio="none" style={{height: "100%", width: "100%"}}>
                <path d="M-14.48,-16.60 C231.56,319.90 382.81,-125.16 503.57,61.34 L500.00,150.00 L0.00,150.00 Z" style={{stroke: "none", fill: "#606c88"}}>
                </path>
            </svg>
        </div>

        <div className="contact" id = "contact">
            <div className="contact__container">
                <HeaderText>Contact</HeaderText>

              
                <div className="contact__content">

                <div>
                <img src={require("../../img/gravatar.jpg")} alt="Muhammad Salim Zakari" className="contact__img" />
                </div>


                <div className = "contact__grid">
                    <Footeritem

                    iconname = "phone-hang-up"
                    itemname = "Phone"
                    itemcontent = "+2349027901840"
                    
                    />
                    <Footeritem
                    
                    iconname = "mail"
                    itemname = "Email"
                    itemcontent = "salimzakari6@gmail"
                    
                    />
                    <Footeritem
                    
                    iconname = "twitter"
                    itemname = "Twitter"
                    itemcontent = "@szakari6"
                    
                    />

                </div>

                <p className = "contact__copyright"> 2022 @ All rights reserved by Salim </p>



                </div>


            </div>
        </div>


        </div>

    )
}
export default Contact;